<template>
  <a-modal :title="viewTitle" visible @cancel="cancel">
    <ak-inputs v-if="getCompleted" :options="editFields" ref="input" v-model="record" />
    <searchInput
      @changeVal="changeVal"
      :label="'所属含量 '"
      :listWhere="listWhere"
      :className="gdData[1].targetClass"
      :objectId="
    typeof record.proportion === 'object'
    ? record.proportion.objectId
    : record.proportion
    "
      :isToggleModel="isToggleModel"
      ref="searchInput"
    />
    <template slot="footer">
      <a-button @click="cancel">取消</a-button>
      <a-button :loading="loading" type="primary" @click="ok">确定</a-button>
    </template>
  </a-modal>
</template>

<script>
import NP from 'number-precision'
import searchInput from './searchInput'
// import store from './../../store'
export default {
  name: 'viewPage',
  data () {
    return {
      models: {
        clientid: {},
        content: '',
        createdAt: '',
        describe: '',
        isBatching: null,
        model: {},
        name: '',
        objectId: '',
        updatedAt: '',
        userid: {},
        workShop: {},
      },
      loading: false,
      getCompleted: false,
      isToggleModel: false,
    }
  },
  components: {
    searchInput
  },
  computed: {
    listWhere () {
      return {
        type: 'ratio',
        workShop: (typeof this.record.workShop === 'object' ? this.record.workShop.objectId : this.record.workShop),
        parentNode: (typeof this.record.model === 'object' ? this.record.model.objectId : this.record.model)
      }
    },
    // validators () {
    //   return {
    //     validators: [ // 表单验证，与model中的validators用法一致
    //       (val) => val ? null : '所属含量不可为空'
    //     ],
    //   }
    // },
    editFields () {
      let data = this.model.fields.filter(field => !field.hideOnEdit)
      let arr = []
      data.forEach((e) => {
        let obj = {}
        if (e.disabled) {
          obj = { ...e.schema, name: e.name }
        } else {
          obj = { ...e.schema, name: e.name }
        }
        arr.push(obj)
      })
      let copyArr = this.$tkHelper.deepClone(this.gdData)
      copyArr[0].listWhere = (where) => {
        where.type = 'model'
        where.workShop = this.record.workShop.objectId
      }
      arr.push(copyArr[0])
      // arr.push(copyArr[1])
      arr[0].validators = [ // 表单验证，与model中的validators用法一致
        (val) => val ? null : '型号不可为空'
      ]
      arr[2].disabled = false
      // if (store.state.user.adminRole === 'workshop') {
      arr[3].disabled = false
      // arr[4].validators = [ // 表单验证，与model中的validators用法一致
      //   (val) => val ? null : '所属型号不可为空'
      // ]
      // } else {
      arr[4].disabled = true
      if (this.record.type === 'model') {
        copyArr[1].listWhere = (where) => {
          where.type = 'ratio'
          where.parentNode = this.record.proportion.onjectId
        }
      }
      arr[5].validators = [ // 表单验证，与model中的validators用法一致
        (val) => val ? null : '所属型号不可为空'
      ]
      // arr[6].validators = [ // 表单验证，与model中的validators用法一致
      //   (val) => val ? null : '所属含量不可为空'
      // ]
      // }
      console.log(arr)
      return arr
    },
  },
  mounted () {
    this.getData()
  },
  watch: {
    // 所属型号
    'record.model': {
      handler: function () {
        if (typeof this.record.model !== 'object') {
          this.record.proportion = ''
          this.$refs.searchInput.gdObjectId = ''
          this.isToggleModel = true
          // this.$refs.searchInput.getInit()
          // this.$forceUpdate()
        }
      },
      deep: true
    }
  },
  methods: {
    changeVal (value) {
      this.record.proportion = value
    },
    async getData () {
      try {
        console.log('record', this.record)
        this.getCompleted = false
        let adjustment = 0
        let incidental = 0
        let profit = 0
        let total = 0
        this.record.price = 0
        if (this.record.adjustment) { adjustment = this.record.adjustment }

        // 获取附加费
        let sur = await this.$tkParse.getData('/classes/surcharge', {
          params: {
            where: {
              type: 'finish',
              proportion: (this.record.proportion ? this.record.proportion.objectId : '')
            }
          }
        }).catch(e => { })
        if (sur.results.length) {
          incidental = sur.results[0].incidental
          profit = sur.results[0].profit
        }
        console.log(this.record.formula, 'this.record.formula')
        if (!(this.record && this.record.formula)) {
          let totalPrice = 0
          totalPrice = NP.plus(incidental, profit, total, adjustment)
          this.record.price = NP.round(totalPrice, 2)
          this.getCompleted = true
          return
        }
        let w = 0
        this.record.formula.forEach((f) => {
          if (f.weight) { w = NP.plus(w, f.weight) }
        })
        let res = []
        let par = []
        // 获取原材料
        if (this.record.rawMaterialId && this.record.rawMaterialId.length) {
          let r = await this.$tkParse.getData('/classes/rawMaterial', {
            params: {
              where: {
                objectId: { $in: this.record.rawMaterialId }
              }
            }
          }).catch(e => {
          })
          res = r.results
        }
        // 获取半成品
        if (this.record.partsId && this.record.partsId.length) {
          let p = await this.$tkParse.getData('/classes/parts', {
            params: {
              where: {
                objectId: { $in: this.record.partsId }
              }
            }
          }).catch(e => { })
          par = p.results
        }
        // 计算材料费
        if (res.length || par.length) {
          this.record.formula.forEach((e) => {
            let rt = NP.divide(e.weight, w, 0.01)
            e.ratio = NP.round(rt, 2)
            e.tonWeight = NP.times(e.ratio, 10)
            if (e.rawMaterial) {
              let s = res.filter((f) => { return e.rawMaterial === f.objectId })
              e.price = NP.times(s[0].price, s[0].rate, e.tonWeight, 0.001, 0.01)
              total = NP.plus(total, e.price)
            }
            if (e.parts) {
              let s = par.filter((g) => { return e.parts === g.objectId })
              e.price = NP.times(s[0].price, e.tonWeight, 0.001)
              total = NP.plus(total, e.price)
            }
          }, this)
        }
        let totalPrice = 0
        totalPrice = NP.plus(incidental, profit, total, adjustment)
        this.record.price = NP.round(totalPrice, 2)
        console.log(this.record.price)
        this.getCompleted = true
        console.log(this.getCompleted)
        this.$forceUpdate()
      } catch (e) {
        this.getCompleted = true
        throw this.$notification['error']({
          message: '网络错误',
          description: '网络错误，请重试'
        })
      }
    },
    async ok () {
      let erros = await this.$refs.input.validate()
      if (Object.keys(erros).length) return // 如果有错误，中断执行，不需要提示（inputs本身具有提示）
      if (!this.$refs.searchInput.gdObjectId) { // 判断含量是否有值
        throw this.$notification['error']({
          message: '您的输入有误',
          description: '含量不可为空'
        })
      }
      this.loading = !this.loading
      let record = this.$tkHelper.deepClone(this.record)
      record.rawMaterialId = (!record.rawMaterialId ? [] : record.rawMaterialId)
      record.partsId = (!record.partsId ? [] : record.partsId)
      record.formula = (!record.formula ? [] : record.formula)
      record.clientid = (typeof record.clientid === 'object' ? record.clientid.objectId : record.clientid)
      record.model = (typeof record.model === 'object' ? record.model.objectId : record.model)
      record.proportion = (typeof record.proportion === 'object' ? record.proportion.objectId : record.proportion)
      record.userid = (typeof record.userid === 'object' ? record.userid.objectId : record.userid)
      record.workShop = (typeof record.workShop === 'object' ? record.workShop.objectId : record.workShop)
      // return
      delete this.record.price
      let res = await this.$tkParse.put(`/classes/finishProduct/${record.objectId}`, record).catch(() => {
        this.loading = !this.loading
        this.$notification['error']({
          message: '网络错误',
          description: '保存数据失败'
        })
      })
      if (res) {
        this.$notification['success']({
          message: '操作成功',
          description: '保存数据成功'
        })
        this.cancel()
        this.vm.refresh()
      }
    },
    cancel () {
      this.$emit('complete', 'cancel')
    }
  },
  props: {
    vm: null,
    record: Object, // 当前行的数据
    model: Object, // 当前model对象
    field: Object, // 当前field对象
    gdData: Array,
    viewTitle: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
</style>
